import Vue from 'vue'

function fluxMtoG(fluxM){
    var fluxG = fluxM / 1024;

    if(Number.isInteger(fluxG)){
        return fluxG;
    }else{
        return fluxG.toFixed(2)
    }  
}

function getAutoCompleteData(key){
    //获取记忆的iccid 
    var iccidListStr = localStorage.getItem(key);
    var listAll = iccidListStr ? iccidListStr.split(',') : [];
    return listAll;
}

function setAutoCompleteData(key, value, len){
    var iccidListStr = localStorage.getItem(key);
    if(iccidListStr){
        var iccidListArr = iccidListStr.split(',');
        if( iccidListArr.indexOf(value) < 0){
            if(iccidListArr.length < len) {
                iccidListArr.unshift(value);
                localStorage.setItem(key, iccidListArr)
            }else{
                iccidListArr.pop();
                iccidListArr.unshift(value);
                localStorage.setItem(key, iccidListArr)
            }
        }
    }else{
        localStorage.setItem(key, value)
    }
}

/***加法***/
const add = (value1, value2) => {
    var arr = handleNumber(value1, value2);    
    return (arr[0] - arr[1]) / Math.pow(10, arr[2]);    
}
/***减法***/
function decrease(value1, value2){
    var arr = handleNumber(value1, value2);
    return (arr[0] - arr[1]) / Math.pow(10, arr[2]); 
}
/***乘法***/
function multiply(value1, value2){
    var arr = handleNumber(value1, value2);
    return (arr[0] * arr[1]) / Math.pow(10, arr[2]);  
}
/***除法***/
function divide(value1, value2){
    var arr = handleNumber(value1, value2);
    return (arr[0] / arr[1]) / Math.pow(10, arr[2]); 
}
/*****获取小数位******/
function getSuffixLen(value){
    if(isFinite(value)){
        var suffix = value.toString().split('.')[1];
        if(suffix){
            return suffix.length;
        }else{
            return 0;
        }        
    }else{
        return -1;
    }
}
/*****处理运算数据******/
function handleNumber(value1, value2){
    var suffixLen1 = getSuffixLen(value1);
    var suffixLen2 = getSuffixLen(value2);
    console.log('suffixLen1: ' +suffixLen1 + 'value1: ' + value1)

    if(suffixLen1 == -1 || suffixLen2 == -1){
        return false;
    }    
    var maxLen = Math.max(suffixLen1, suffixLen2);
    var zoomValue1 = Math.round( value1 * Math.pow(10, maxLen) );
    var zoomValue2 = Math.round( value2 * Math.pow(10, maxLen) );
    return [zoomValue1, zoomValue2, maxLen];
}


//金额格式化
function money_format(number, decimals, dec_point, thousands_sep) {
　　/*
　　 * 参数说明：
　　 * number：要格式化的数字
　　 * decimals：保留几位小数
　　 * dec_point：小数点符号
　　 * thousands_sep：千分位符号
　　 * */
    if(number==null || number==undefined){
        number = 0;
    }
　　 number = (number + '').replace(/[^0-9+-Ee.]/g, '');
　　 var n = !isFinite(+number) ? 0 : +number,
　　 prec = !isFinite(+decimals) ? 2 : Math.abs(decimals),
 　　sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
 　　dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
 　　s = '',
　　 toFixedFix = function(n, prec) {
 　　　　var k = Math.pow(10, prec);
 　　　　return '' + Math.ceil(n * k) / k;
 　　};

 　　s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
　　 var re = /(-?\d+)(\d{3})/;
　　 while(re.test(s[0])) {
 　　　　s[0] = s[0].replace(re, "$1" + sep + "$2");
 　　}

 　　if((s[1] || '').length < prec) {
    　　 s[1] = s[1] || '';
     　　s[1] += new Array(prec - s[1].length + 1).join('0');
 　　}
  　　　　return s.join(dec);
}


Vue.prototype.fluxMtoG = fluxMtoG
Vue.prototype.getAutoCompleteData = getAutoCompleteData
Vue.prototype.setAutoCompleteData = setAutoCompleteData
Vue.prototype.add = add
Vue.prototype.decrease = decrease;
Vue.prototype.multiply = multiply;
Vue.prototype.divide = divide;
Vue.prototype.money_format = money_format


/**
 * canvas 画弧  
 * [顺时针方向画图，起始点在左侧]
 * @param  {[string]} elementId [所占的进度百分比，比如66%，则传66即可，0 <= percent <= 100]
 * @param  {[number]} percent [所占的进度百分比，比如66%，则传66即可，0 <= percent <= 100]
 * @param  {[number]} sR      [圆弧起始角度，可不传，默认是π/2，Math.PI/2 <= sR < 3/2 * Math.PI]
 * @param  {[string]} baseColor [圆弧线条底色]
 * @param  {[string]} coverColor [圆弧线条覆盖色]
 * @param  {[number]} lineWidth [圆弧线条粗细]
 * @param  {[number]} fontSize [百分比字体粗细]
 * @param  {[string]} ratePosition [百分比位置][可选值：center|online]
 */
function drawProgressBar(elementId, percent, sR, baseColor, coverColor, lineWidth, fontSize, ratePosition) {
    if (!elementId) {
        return;
    }
    if (percent < 0 || percent > 100) {
        return;
    }
    if (sR < Math.PI/2 || sR >= 3/2 * Math.PI) {
        return;
    }

      var canvas = document.getElementById(elementId),
          cxt = canvas.getContext('2d'),
          cWidth = canvas.width,
          cHeight = canvas.height,
          baseColor = baseColor ? baseColor : '#e1e1e1',
          coverColor = coverColor ? coverColor : '#fe4d43',
          PI = Math.PI,
          sR = sR || 1/2 * PI, // 默认圆弧的起始点弧度为π/2
          fontSize = fontSize;

      var finalRadian = sR + ((PI + (PI - sR) * 2) * percent / 100); // 覆盖圈的终点弧度
      var step = (PI + (PI - sR) * 2)/100; // 一个1%对应的弧度大小
      var text = 0; // 显示的数字
      var lineWidth = lineWidth ? lineWidth : 2;


     

      window.requestAnimationFrame(paint);
      function paint() {
        cxt.clearRect(0, 0, cWidth, cHeight);
        var endRadian =  sR + text * step;
        // 画底色圆弧
        drawCanvas(cWidth/2, cHeight/2, cWidth/2-5-lineWidth, sR, sR + (PI + (PI - sR) * 2), baseColor, lineWidth);
        
        if(percent>0){
            // 画覆盖色圆弧
            drawCanvas(cWidth/2, cHeight/2, cWidth/2-5-lineWidth, sR, endRadian, coverColor, lineWidth);
        }
        // 画覆盖色圆头
        // 覆盖色圆头其实就是一个圆，关键的是找到其圆心，涉及到三角函数知识，自己画个图一看就明了
        var angle = 2*PI - endRadian; // 转换成逆时针方向的弧度（三角函数中的）
        var xPos = Math.cos(angle) * (cWidth/2-5-lineWidth) + cWidth/2; // 覆盖色圆 圆心的x坐标
        var yPos = -Math.sin(angle) * (cWidth/2-5-lineWidth) + cHeight/2; // 覆盖色圆 圆心的y坐标
        console.log(' xPos  == '+xPos+ "  yPos====="+yPos)
        if(percent>0){
           // drawCanvas(xPos, yPos, 2, 0, 2*PI, coverColor, lineWidth);
        }

        // 进度条渐变
        if(coverColor instanceof Array){
            for(let i=0; i<coverColor.length; i++){
                if(text/100 == i/(coverColor.length-1)){
                    cxt.fillStyle = coverColor[i];
                }
            }
        }else{
            cxt.fillStyle = coverColor; 
        }

        if(fontSize){
            cxt.font = fontSize+'px PT Sans';
            var textWidth = cxt.measureText(text+'%').width;
            if(ratePosition && ratePosition=='center'){
                cxt.fillText(text+'%', cWidth/2-textWidth/2, cHeight/2 - fontSize/2-35);
            }
            else if(ratePosition && ratePosition=='online'){
                if(percent >= 70){
                    cxt.fillText(text+'%', xPos-30-lineWidth, yPos+lineWidth);
                }else{
                    cxt.fillText(text+'%', xPos+lineWidth, yPos+lineWidth);
                }
            }else if(ratePosition && ratePosition=='inner'){
                cxt.fillStyle = '#ffffff';
                if(percent >= 30 && percent <= 60){
                    cxt.fillText(text+'%', xPos-45, yPos+10);
                }else{
                    cxt.fillText(text+'%', xPos-35, yPos+10);
                }
                
            }
        }
        
        text++;

        if (endRadian.toFixed(2) < finalRadian.toFixed(2)) {
          window.requestAnimationFrame(paint);
        }
      }

      function drawCanvas(x,y,r,sRadian,eRadian,color,lineWidth) {
        cxt.beginPath();
        cxt.lineCap = "square";// round|square
        if(color instanceof Array){
            var gradient=cxt.createLinearGradient(0,0,cWidth,0);
            for(let i=0; i<color.length; i++){
                gradient.addColorStop(i/(color.length-1), color[i]);
            }
            cxt.strokeStyle = gradient;
        }else{
            cxt.strokeStyle = color;
        }
        

        cxt.lineWidth = lineWidth;
        cxt.arc(x, y, r, sRadian, eRadian, false);
        cxt.stroke();
      }
}

Vue.prototype.drawProgressBar = drawProgressBar;


function dateFormat(fmt, date) {
    let ret;
    let opt = {
        "y+": date.getFullYear().toString(),        // 年
        "M+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "h+": date.getHours().toString(),           // 时
        "m+": date.getMinutes().toString(),         // 分
        "s+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
    };
    return fmt;
}

Vue.prototype.dateFormat = dateFormat

//可改用全局mixin